import { h, mergeProps, ref } from 'vue';
import SlideshowElement from './Widgets/Slideshow/Slideshow.vue';
import GroupElement from './Group.vue';
import TextElement from './Text.vue';
import ImageElement from './Image.vue';
import RectangleElement from './Rectangle.vue';
import TriangleElement from './Triangle.vue';
import OvalElement from './Oval.vue';
import DateElement from './Widgets/Date.vue';
import QRCodeElement from './Widgets/Qrcode.vue';
import TimerElement from './Widgets/Timer.vue';
import VideoElement from './Video.vue';
import MultiMediaElement from './MultiMedia.vue';
import LinkedDataElement from './LinkedData.vue';
import MarqueeElement from './Marquee/MarqueeWrapper.vue';
import MarqueeText from './Marquee/MarqueeText.vue';
import MarqueeImage from './Marquee/MarqueeImage.vue';
import Frame from './Frame.vue';
import SheetDataElement from './DataProvider/GoogleSheets.vue';
import DataListElement from './DataList.vue';
import SportradarElement from './DataProvider/Sportradar.vue';
import SocialDataElement from './DataProvider/Social.vue';
import ShoppableElement from './DataProvider/Shoppable.vue';

const components = {
  text: TextElement,
  group: GroupElement,
  image: ImageElement,
  rectangle: RectangleElement,
  triangle: TriangleElement,
  oval: OvalElement,
  slideshow: SlideshowElement,
  date: DateElement,
  qrcode: QRCodeElement,
  timer: TimerElement,
  video: VideoElement,
  'multi-media': MultiMediaElement,
  'social-data': SocialDataElement,
  'social-display': Frame,
  'poll-display': Frame,
  frame: Frame,
  'sheet-data': SheetDataElement,
  'data-list': DataListElement,
  sportradar: SportradarElement,
  'linked-data': LinkedDataElement,
  marquee: MarqueeElement,
  'marquee-text': MarqueeText,
  'marquee-image': MarqueeImage,
  shoppable: ShoppableElement,
};

export default {
  name: 'ElementRenderer',
  inheritAttrs: false,
  props: {
    type: { type: String, required: true },
  },
  setup(props, { attrs, slots, expose }) {
    const child = ref(null);
    // Group editing reads these members through refs on ElementRenderer.
    expose({
      get $el() { return child.value?.$el; },
      get translateDrag() { return child.value?.translateDrag; },
      get tweenMaxTransforms() { return child.value?.tweenMaxTransforms; },
    });

    return () => {
      const component = components[props.type];
      return component ? h(component, mergeProps(attrs, { ref: child }), slots) : null;
    };
  },
};
